<mat-spinner *ngIf="isLoading" class="loading-spinner"></mat-spinner>

<div class="container-inclusionIndex" *ngIf="!isLoading">
  <app-alert-message></app-alert-message>

  <div class="container-top">
    <header>
      <h1>
        {{ 'inclusion-index.title' | translate }}
        <mat-icon class="info-icon" (click)="openInfoDialog()">info</mat-icon>
      </h1>
      <p>{{ 'inclusion-index.description' | translate }}</p>
    </header>

    <div class="pulsanti">
      <button class="newsButton" (click)="toTrainingCourse()">
        <mat-icon>assignment icon</mat-icon>
        {{ 'inclusion-index.training-course' | translate }}
      </button>

      <button
        class="newsButton"
        (click)="fillQuestionnaire()"
        [disabled]="!isQuestionnaireAvailable"
        [matTooltip]="tooltipReasonKey ? (tooltipReasonKey | translate: tooltipReasonParams) : ''"
        matTooltipPosition="above"
      >
        <mat-icon>text_snippet</mat-icon>
        {{ 'inclusion-index.start-new-questionnaire' | translate }}
      </button>

      <button
        class="newsButton"
        (click)="recalculateIndex()"
        [disabled]="!isRecalculatingAvailable"
        [matTooltip]="(isRecalculatingAvailable ? 'inclusion-index.recalculate-tooltip-enabled' : 'inclusion-index.recalculate-tooltip-disabled') | translate"
        matTooltipPosition="above"
      >
        <mat-icon>update</mat-icon>
        {{ 'inclusion-index.recalculate-index-now' | translate }}
      </button>
    </div>
  </div>

  <div class="container-middle">
    <section class="metrics" *ngIf="dashboarInclusionIndexdData as data">
      <div class="metric-card blue">
        <div class="mc-left">
          <h2>{{ 'inclusion-index.current-score' | translate }}</h2>
          <p class="score">{{ data.inclusionIndex | number:'1.1-2' }}</p>
          <span>
            <mat-icon class="small-icon">
              {{ data.progressDelta < 0 ? 'arrow_downward' : 'arrow_upward' }}
            </mat-icon>
            {{ data.progressDelta !== null
              ? (data.progressDelta > 0 ? '+' : '') + (data.progressDelta | number:'1.2-2')
              : ('inclusion-index.not-available' | translate) }}
            {{ 'inclusion-index.from-last' | translate }}
          </span>
        </div>
        <div class="mc-right">
          <mat-icon class="icon-top">show_chart</mat-icon>
        </div>
      </div>

      <div class="metric-card light-blue">
        <div class="mc-left">
          <h2>{{ 'inclusion-index.assessments' | translate }}</h2>
          <p class="level">{{ data.completedSelfAssessments }}</p>
          <span>{{ 'inclusion-index.completed' | translate }}</span>
        </div>
        <div class="mc-right">
          <mat-icon class="icon-top">check</mat-icon>
        </div>
      </div>

      <div class="metric-card yellow">
        <div class="mc-left">
          <h2>{{ 'inclusion-index.level' | translate }}</h2>
          <p class="level">{{ inclusionLevelTranslate() | translate}}</p>
          <span>
            {{ 'inclusion-index.corresponding' | translate }}: {{ data.letterGrade }}
          </span>
        </div>
        <div class="mc-right">
          <span>{{ data.letterGrade }}</span>
        </div>
      </div>

      <div class="metric-card">
        <div class="mc-left">
          <h2>{{ 'inclusion-index.next-assessment' | translate }}</h2>
          <p class="reviews">
            <ng-container *ngIf="data.nextSuggestedAssessment; else noDate">
              {{ data.nextSuggestedAssessment | date:'dd/MM/yyyy' }}
            </ng-container>
            <ng-template #noDate>{{ 'inclusion-index.not-available' | translate }}</ng-template>
          </p>
          <span>{{ 'inclusion-index.recommended' | translate }}</span>
        </div>
        <div class="mc-right">
          <mat-icon class="icon-top">calendar_month</mat-icon>
        </div>
      </div>
    </section>
  </div>

  <div class="container-inclusion-bottom">
    <div class="left">
      <div class="title">
        <h1>
          <mat-icon>business</mat-icon>
          {{ 'inclusion-index.history-title' | translate }}
        </h1>
      </div>
      <div class="content-inclusion-assesment">
        <div *ngIf="questionnairesSelfAssessments.length > 0; else noSelfAssessments">
          <div class="assessment-card" *ngFor="let qCompany of questionnairesSelfAssessments; let i = index">
            <div class="assessment-header">
              <div class="assessment-header-left">
                <h2>
                  {{ 'inclusion-index.assessment' | translate }} #{{ i + 1 }}
                  <span class="status completed">
                    &#10003; {{ 'inclusion-index.completed' | translate }}
                  </span>
                </h2>
                <p>
                  {{ 'inclusion-index.compiled-by' | translate }}:
                  <strong>{{ qCompany.firstName }} {{ qCompany.lastName }}</strong>
                </p>
                <p>
                  {{ 'inclusion-index.completed-on' | translate }}
                  <strong>{{ qCompany.dateCompilation | date:'dd/MM/yyyy' }}</strong>
                </p>
              </div>
              <div class="assessment-header-rigth">
                <span class="score">
                  {{ qCompany.totalScore | number:'1.1-2' }}
                  <span class="grade">{{ qCompany.letter }}</span>
                </span>
              </div>
            </div>

            <p>
              {{ 'inclusion-index.level-label' | translate }}:
              <strong>{{ qCompany.level }}</strong>
            </p>

            <div class="assessment-footer">
              <button class="view-btn" (click)="viewQuestionnaireCompany(qCompany)">
                {{ 'inclusion-index.view-results' | translate }}
              </button>
              <button class="export-btn" (click)="exportQuestionnaire(qCompany.questionnaireId)">
                {{ 'inclusion-index.export' | translate }}
              </button>
            </div>
          </div>
        </div>

        <ng-template #noSelfAssessments>
          <p class="empty-message">{{ 'inclusion-index.no-self-assessments' | translate }}</p>
        </ng-template>
      </div>
    </div>

    <div class="right">
      <div class="title">
        <h1>
          <mat-icon>groups</mat-icon>
          {{ 'inclusion-index.recent-trainee-questionnaires' | translate }}
          <span *ngIf="questionnairesTrainee.length > 0" class="count-badge">
            ({{ questionnairesTrainee.length }})
          </span>
        </h1>
      </div>

      <div class="content-questionnaire-trainees">
        <div *ngIf="questionnairesTrainee.length > 0; else noTraineeAssessments">
          <div class="trainee-card" *ngFor="let q of questionnairesTrainee">
            <div class="trainee-info">
              <div class="trainee-header">
                <div class="trainee-header-left">
                  <h2>{{ q.firstName }} {{ q.lastName }}</h2>
                  <p>{{ q.position }}</p>
                </div>
                <div class="trainee-header-rigth">
                  <span class="score">{{ q.totalScore | number:'1.2-2' }}</span>
                </div>
              </div>
              <div class="trainee-footer">
                <p>
                  {{ 'inclusion-index.completed-on' | translate }}
                  <strong>{{ q.dateCompilation | date:'dd/MM/yyyy' }}</strong>
                </p>

                <div class="trainee-actions">
                  <mat-icon class="view-btn" (click)="viewQuestionnaireTrainee(q)">remove_red_eye</mat-icon>
                  <mat-icon class="view-btn" (click)="exportQuestionnaire(q.questionnaireId)">file_download</mat-icon>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ng-template #noTraineeAssessments>
          <p class="empty-message">{{ 'inclusion-index.no-trainee-assessments' | translate }}</p>
        </ng-template>

        <button *ngIf="questionnairesTrainee.length > 0" class="view-all-btn" (click)="viewAllTraineeAssessments()">
          {{ 'inclusion-index.view-all-trainee-assessments' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
